import Axios from 'axios';
import { addHours, isAfter } from 'date-fns';
import { generateGuid } from '~/utils/auth';
import Env from '~/env';
import { LocalStorage } from '~/storage/LocalStorage';
import { AUTH_INTEGRATION } from '~/storage/constants';
import type { MarisaPSFTokenDTO } from '~/dto/PSF';
import type { TokenType } from '~/domain/PSF';
import {
  DEFAULT_USER,
  INTEGRATION_DOCUMENT,
  SERVICE_ACCOUNT_TOKEN,
} from '~/consts/psf';

export const integrationAuth = async (): Promise<TokenType | null> => {
  const auth = await LocalStorage.get(AUTH_INTEGRATION);
  if (auth) {
    const token = JSON.parse(auth) as TokenType;

    if (isAfter(new Date(token.expiresIn), new Date())) {
      return token;
    }
  }

  const idProcesso = generateGuid();

  const data = {
    cpfUsuario: INTEGRATION_DOCUMENT,
    loginUsuario: DEFAULT_USER,
    service: 'auth',
    functionality: '',
    filial: 1033,
    idProcesso,
    idServico: generateGuid(),
    ipUsuario: '10.10.10.1',
    password: 'qdkuhk76787$@ghJ',
    serviceAccountToken: SERVICE_ACCOUNT_TOKEN,
  };

  try {
    const response = await Axios.post<MarisaPSFTokenDTO>(
      `https://${Env.PSF_AUTH_HOST}/security/api/auth`,
      data
    );
    if (response.status === 200) {
      const expiresIn = addHours(new Date(), 1).toString();

      await LocalStorage.set(
        AUTH_INTEGRATION,
        JSON.stringify({
          idProcesso,
          token: response.data.token,
          expiresIn,
        })
      );

      return {
        idProcesso: idProcesso,
        token: response.data.token,
        expiresIn,
      };
    }

    throw new Error('Problema ao tentar autenticar.');
  } catch (e) {
    LocalStorage.remove(AUTH_INTEGRATION);
    return null;
  }
};

//Object for role ANON_SVC

const apiPSFAnon = Axios.create({
  baseURL: `https://${Env.PSF_SERVICES_HOST}/`,
});

apiPSFAnon.interceptors.request.use(async (config) => {
  const credentials = await integrationAuth();

  if (credentials) {
    config.headers.Authorization = `Bearer ${credentials.token}`;
  }

  if (config.method?.toUpperCase() === 'POST') {
    config.data.loginUsuario = DEFAULT_USER;
  } else if (config.method?.toUpperCase() === 'GET') {
    config.headers.idProcesso = credentials?.idProcesso;
    config.headers.idServico = generateGuid();
  }

  return config;
});

export default apiPSFAnon;
